



































































import { Component, Mixins } from 'vue-property-decorator';
import InfiniteLoading from 'vue-infinite-loading';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import commonEntry from '@/store/modules/commonEntry';
import { ScreenText } from '@/lang/ScreenText';
import catalogStore from '@/store/modules/catalog/module';
import CatalogCard from '@/components/familyPortal/catalogContainer/catalogContent/sessions/CatalogCard.vue';
import { CatalogSession } from '@/Model/sessions/catalogTypes';
import EmptyStateCard from '@/components/familyPortal/catalogContainer/catalogContent/EmptyStateCard.vue';
import ResultIcon from '@/components/icons/result-icon.vue';
import BouncingPreloader from '@/commoncomponents/bouncingpreloadercomponent/BouncingPreloaderComponent.vue';

interface ProgramSessions {
  name: string;
  sessions: Array<CatalogSession>;
}

@Component({
  components: {
    BouncingPreloader,
    InfiniteLoading,
    CatalogCard,
    EmptyStateCard,
    ResultIcon,
  }
})
export default class CatalogSessionList extends Mixins(DeviceWidthCheckerMixin) {
  private screenText = new ScreenText();

  get designColor(): string {
    return commonEntry.accountDesignDetails.accentColor;
  }

  /**
   * Total number of sessions
   */
  get totalSessionCount(): number {
    return catalogStore.unfilteredCatalogSessionData.length;
  }

  /**
   * Number of sessions currently loaded in the store
   */
  get availableSessionCount(): number {
    return catalogStore.currentCatalogSessionList.length;
  }

  /**
   * Number of sessions to display (based on filters)
   */
  get filteredSessionCount(): number {
    return catalogStore.totalSetCount;
  }

  get isLoadingSessions(): boolean {
    return catalogStore.isLoadingSessions;
  }

  get isInitialLoad(): boolean {
    return catalogStore.isInitialLoadingSessions;
  }

  get loadingId(): number {
    return catalogStore.loadingId;
  }

  get sessionCountText(): string {
    const postKey = this.totalSessionCount == 1
      ? 'CATALOG_SESSIONCOUNT_POST_SINGULAR'
      : 'CATALOG_SESSIONCOUNT_POST_PLURAL';
    const pre = this.screenText.getScreenText('CATALOG_SESSIONCOUNT_PRE');
    const post = this.screenText.getScreenText(postKey);
    if (this.filteredSessionCount == this.totalSessionCount) {
      return `${pre} ${this.totalSessionCount} ${post}`;
    }

    const mid = this.screenText.getScreenText('CATALOG_SESSIONCOUNT_MID');
    return `${pre} ${this.filteredSessionCount} ${mid} ${this.totalSessionCount} ${post}`;
  }

  get emptyResultHeadingText(): string {
    const key = this.isMobile
      ? 'CATALOG_FILTER_EMPTY_HEADING_MOBILE'
      : 'CATALOG_FILTER_EMPTY_HEADING';
    return this.screenText.getScreenText(key);
  }

  get emptyResultMessageText(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_EMPTY_MESSAGE');
  }

  get programsAndSessions(): ProgramSessions[] {
    const programSessionList: ProgramSessions[] = [];
    const catalogSessionList = catalogStore.currentCatalogSessionList;

    if (catalogSessionList.length < 1) {
      return programSessionList;
    }

    let index = 0;
    let currentProgramId = catalogSessionList[0].programId;
    programSessionList.push({ name: catalogSessionList[0].programName, sessions: [] });

    catalogSessionList.forEach((session) => {
      if (session.programId != currentProgramId) {
        index++;
        currentProgramId = session.programId;
        programSessionList.push({ name: session.programName, sessions: [] });
      }
      programSessionList[index].sessions.push(session);
    });
    return programSessionList;
  }

  get errorMessage(): string {
    return (catalogStore.sessionsFetchError && catalogStore.sessionsFetchError.value) || '';
  }

  async infiniteHandler($state: any) {
    await catalogStore.retrieveCatalogSessions(commonEntry.accountDesignDetails.accountId);

    if (catalogStore.didSessionFetchFail === false) {
      if (catalogStore.shouldLoadMoreSessions) {
        $state.loaded();
      }
      else {
        $state.complete();
      }
    }
    else {
      $state.error();
    }
  }
}
